import { Box } from '@mui/material'
import AppleLoginBtn from '~/src/components/auth/social-logins/AppleLoginBtn'
import { useCustomMuiTheme } from '~/src/hooks/useCustomMuiTheme'
import GoogleLoginBtn from '~/src/components/auth/social-logins/GoogleLoginBtn'
import { SocialLoginType } from '@eo-storefronts/eo-core'
import {
  LoginTypeSelectionFormActionTypes
} from '~/src/components/auth/login-type-selection/LoginTypeSelectionFormActions'

interface Props {
  isLoading?: boolean,
  loginTypeSelectionFormActionClicked: LoginTypeSelectionFormActionTypes | null,
  onClick?(type: SocialLoginType): void,
}

const SocialLogins = ({ onClick, loginTypeSelectionFormActionClicked, isLoading = false }: Props) => {
  const muiTheme = useCustomMuiTheme()

  const handleOnClick = (type: SocialLoginType) => {
    onClick && onClick(type)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        [muiTheme.breakpoints.down('sm')]: {
          gap: 1
        }
      }}
    >
      <GoogleLoginBtn
        isLoading={isLoading && loginTypeSelectionFormActionClicked === 'google'}
        disabled={isLoading}
        onClick={() => handleOnClick('google')}/>
      <AppleLoginBtn
        isLoading={isLoading && loginTypeSelectionFormActionClicked === 'apple'}
        disabled={isLoading}
        onClick={() => handleOnClick('apple')}/>
    </Box>
  )
}

export default SocialLogins
